import { render, staticRenderFns } from "./SurveyAnswerPage.vue?vue&type=template&id=1bc59a45&scoped=true"
import script from "./SurveyAnswerPage.vue?vue&type=script&lang=js"
export * from "./SurveyAnswerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc59a45",
  null
  
)

export default component.exports